
<template>
	<v-container fluid="fluid" class="pa-4">
		<v-layout row wrap>
			<v-btn fixed dark fab bottom right color="pink" @click="createUnit()">
				<v-icon>add</v-icon>
			</v-btn>
			<units-table
				@showUnit="showUnit"
				:dataType="dataType"
				:dataTimeStamp="dataTimeStamp"
				>></units-table
			>
		</v-layout>
		<unit-modal
			:id="unit.unitId"
			:edit="edit"
			@updateUnits="updateUnits()"
			ref="unitModal"
		></unit-modal>
	</v-container>
</template>
<script>
import UnitsTable from '@/components/Units/UnitsTable';
import UnitModal from '@/components/Units/UnitModal';
export default {
	name: 'Units',
	components: { UnitsTable, UnitModal },
	data() {
		return {
			unit: {
				edit: false
			},
			src: '',
			edit: {
				showModal: false
			},
			tabs: ['Used', 'Unused'],
			active: 'Used',
			text: ['In gebruik', 'Beschikbaar'],
			dataType: 'getUnits',
			dataTimeStamp: 0,
			availableDataTypes: {
				Used: 'getUnits',
				Unused: 'getWialonUnits'
			}
		};
	},
	created() {},
	watch: {
		active(val) {
			this.dataType = this.availableDataTypes[val];
		}
	},
	methods: {
		showUnit(unit) {
			let editUnit = Object.assign({}, unit);
			this.$refs.unitModal.image = '';
			this.$refs.unitModal.unitData = editUnit;
			this.$refs.unitModal.showModal = true;
		},
		createUnit() {
			const unit = {
				new: true,
				edit: true,
				parkingLat: '0',
				parkingLng: '0',
				fuelCardPin: '0',
				standplaats: '-'
			};

			this.$refs.unitModal.image = '';
			this.$refs.unitModal.unitData = unit;
			this.$refs.unitModal.showModal = true;
		},
		updateUnits() {
			this.dataTimeStamp = new Date();
		}
	}
};
</script>



// WEBPACK FOOTER //
// src/components/Units/Units.vue